/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const utentiAPI = {
  list: async (role, search) => {
    const params = {};
    if (role) params.role = role;
    if (search) params.search = search;
    const { data } = await apiClient.get('/utenti', { params });
    return data;
  },

  create: async (utente) => {
    const { data } = await apiClient.post('/utenti', utente);
    return data;
  },

  update: async (id, utente) => {
    const { data } = await apiClient.put(`/utenti/${id}`, utente);
    return data;
  },

  toggleAttivo: async (id, attivo) => {
    const { data } = await apiClient.patch(`/utenti/${id}/attivo`, { attivo });
    return data;
  },
};
